import React from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import ArrowForward from "@mui/icons-material/ArrowForward";

function WhoWeAre() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
 const is4K = useMediaQuery("(min-width: 3840px)");

  // Dynamic padding that matches header exactly
  const getResponsivePadding = () => {
    if (isMobile) return "16px";
    if (isTablet) return "40px"; // Intermediate padding for tablet
    return "60px"; // Desktop padding
  };

  return (
<>
      {/* Preload LCP images */}
      <link
        rel="preload"
        as="image"
        href="/close-up-young-business-person-480w.webp"
        media="(max-width: 480px)"
        fetchpriority="high"
      />
      <link
        rel="preload"
        as="image"
        href="/close-up-young-business-person-768w.webp"
        media="(max-width: 768px)"
        fetchpriority="high"
      />
      <link
        rel="preload"
        as="image"
        href="/close-up-young-business-person-doing-internship.webp"
        media="(min-width: 769px)"
        fetchpriority="high"
      />
      <Box
        component="section"
        role="region"
        aria-labelledby="level-up-heading"
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          my: { xs: 4, sm: 6, md: 8 },
        }}
      >
        {/* Main Content Container */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            pl: { xs: 2, sm: 2, md: is4K ? "1200px" : "210px" },
            pr: { xs: 2, sm: "0px", md: is4K ? "1200px" : "210px" },
            py: { xs: 4, sm: 6, md: 8 },
          }}
        >
          <Grid
            container
            spacing={8}
            sx={{ maxWidth: "xl", alignItems: "start" }}
          >
            {/* Left Side Image */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Box
                component="picture"
                sx={{
                  width: { xs: "85%", sm: "79%", md: "100%" },
                  height: "auto",
                  maxHeight: "700px",
                }}
              >
                {/* Responsive WebP sources with proper sizing */}
                <source
                  srcSet={`
                    /close-up-young-business-person-480w.webp 480w,
                    /close-up-young-business-person-768w.webp 768w,
                    /close-up-young-business-person-doing-internship.webp 1200w
                  `}
                  sizes={
                    isMobile 
                      ? "(max-width: 480px) 480px, (max-width: 768px) 768px, 100vw"
                      : isTablet 
                      ? "(max-width: 768px) 768px, (max-width: 1200px) 1200px, 100vw"
                      : "(max-width: 1200px) 1200px, 100vw"
                  }
                  type="image/webp"
                />
                
                {/* Fallback JPEG sources */}
                <source
                  srcSet={`
                    /close-up-young-business-person-doing-internship.jpg 480w,
                    /close-up-young-business-person-doing-internship.jpg 768w,
                    /close-up-young-business-person-doing-internship.jpg 1200w
                  `}
                  sizes={
                    isMobile 
                      ? "(max-width: 480px) 480px, (max-width: 768px) 768px, 100vw"
                      : isTablet 
                      ? "(max-width: 768px) 768px, (max-width: 1200px) 1200px, 100vw"
                      : "(max-width: 1200px) 1200px, 100vw"
                  }
                  type="image/jpeg"
                />
                
                <Box
                  component="img"
                  src="/close-up-young-business-person-doing-internship-1200w.webp"
                  alt="DevAngles team members collaborating at a modern workspace, using laptops and digital tools to develop innovative AI and cloud solutions"
                  width={isMobile ? "480" : isTablet ? "768" : "1200"}
                  height={isMobile ? "320" : isTablet ? "512" : "800"}
                  sx={{
                    width: "100%",
                    height: "auto",
                    maxHeight: "700px",
                    objectFit: "cover",
                    borderRadius: "15px",
                    aspectRatio: "3/2", // Prevent layout shift
                  }}
                  loading="eager" // LCP element
                  fetchpriority="high"
                  decoding="sync"
                />
              </Box>
            </Grid>

          {/* Right Side Content */}
          
          <Grid
            item
             role="region"
  aria-labelledby="level-up-heading"
            xs={12}
            md={6}
            sx={{
              textAlign: { xs: "left", sm: "left" },
              marginRight: { xs: "30px", sm: "90px", md: "0px" },
              marginLeft: { xs: "65px", sm: "84px", md: "0px" },
            }}
          >
            <Typography
             id="level-up-heading"
              sx={{
                fontSize: isMobile ? "16px" : isTablet ? "18px" : "18px",
                textTransform: "uppercase",
                color: "#0087B4",
                fontWeight: 600,
              }}
            >
              Level Up With DevAngles
            </Typography>
            <Typography
              sx={{
                fontSize: isMobile ? "35px" : isTablet ? "40px" : "42px",
                textTransform: "capitalize",
                lineHeight: "1.2",
                mt: 1.5,
                fontWeight: 400,
              }}
            >
              Accelerate your growth with DevAngles
            </Typography>
            <Typography
              sx={{
                fontSize: isMobile ? "16px" : isTablet ? "18px" : "18px",
                mt: 3,
                fontWeight: 300,
                color: "#000000DE",
              }}
            >
              At DevAngles, we believe your career should grow as fast as the technology you work with. We don’t just build AI, Cloud, and Data solutions — we build people. We provide a space where learning never stops and impact is real.
            </Typography>
            
          </Grid>
        </Grid>
      </Box>
    </Box>
    </>
  );
}

export default WhoWeAre;

